export interface NativeCheckboxProps {
  label?: string
  toolTip?: string
  disabled?: boolean
  selected?: boolean
  onChange: (checked: boolean) => void
}

const NativeCheckbox = ({ label, toolTip, disabled, selected, onChange }: NativeCheckboxProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }} title={toolTip}>
      <input
        type={'checkbox'}
        style={{ width: '16px', height: '16px' }}
        disabled={disabled}
        checked={selected}
        onChange={(event) => {
          onChange(event.target.checked)
        }}
      />
      {label && <label style={{ paddingLeft: '8px' }}>{label}</label>}
    </div>
  )
}

export default NativeCheckbox
